import { SagaIterator } from 'redux-saga'
import { CADASTRO_MODELO, CadastroModeloReq } from './types'
import { ApplicationState } from 'store'
import * as loadingActions from 'store/modules/loading/actions'
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'
import * as cadastroModeloController from 'controller/modelosMensagensChatWootController'
import * as cadastroModeloActions from 'store/modules/backoffice/cadastroModelo/actions'
import { TYPES } from './types'
import { handlerError } from 'util/handlerError'
import { toast } from 'react-toastify'

interface GenericProps {
  type: string
  id: string
}

function* getAllModeloMensagem(): SagaIterator {
  const { pagination, limiteMaximoRegistros }: CADASTRO_MODELO = yield select(
    (state: ApplicationState) => state.cadastroModelo
  )

  try {
    yield put(loadingActions.setLoading(true))

    const response = yield call(
      cadastroModeloController.getAllModelosMensagensChatWoot,
      {
        pagina: pagination.page,
        registros: pagination.pageSize,
        limiteMaximoRegistros: limiteMaximoRegistros
      }
    )

    yield put(
      cadastroModeloActions.setPaginacao({
        ...pagination,
        totalRegistros: response?.data?.content?.quantidadeTotal
      })
    )

    yield put(
      cadastroModeloActions.setAllCadastroModelo(
        response?.data?.content?.registros
      )
    )

    yield put(cadastroModeloActions.cleanRegister())
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* criarCadastroModelo(): SagaIterator {
  const { register }: CADASTRO_MODELO = yield select(
    (state: ApplicationState) => state.cadastroModelo
  )

  try {
    yield put(loadingActions.setLoading(true))

    yield call(
      cadastroModeloController.createModeloMensagemChatWoot,
      register.atalho,
      register.descricao
    )

    yield put(
      cadastroModeloActions.setPaginacao({
        page: 0,
        pageSize: 10,
        totalRegistros: 0
      })
    )
    yield put(cadastroModeloActions.setActiveTab('search'))
    yield put(cadastroModeloActions.getAllModeloMensagemSaga())
    yield put(cadastroModeloActions.cleanRegister())
    toast.success('Modelo criado com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* deleteCadastroModelo(): SagaIterator {
  const { itemSelectedId }: CADASTRO_MODELO = yield select(
    (state: ApplicationState) => state.cadastroModelo
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(
      cadastroModeloController.deleteModeloMensagemChatWoot,
      itemSelectedId
    )
    yield put(
      cadastroModeloActions.setPaginacao({
        page: 0,
        pageSize: 10,
        totalRegistros: 0
      })
    )
    yield put(cadastroModeloActions.getAllModeloMensagemSaga())
    yield put(cadastroModeloActions.cleanRegister())
    yield put(cadastroModeloActions.toggleModalExclusaoDispatch(false))
    toast.success('Modelo deletado com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* editarCadastroModelo({ id }: GenericProps): SagaIterator {
  yield put(loadingActions.setLoading(true))
  try {
    const response = yield call(
      cadastroModeloController.getByIdModeloMensagemChatWoot,
      id
    )
    const modelos: CadastroModeloReq = {
      id: response?.data?.content?.id,
      atalho: response?.data?.content?.nome,
      descricao: response?.data?.content?.descricao
    }
    yield put(cadastroModeloActions.setRegister(modelos))
    yield put(cadastroModeloActions.setActiveTab('register'))
    yield put(cadastroModeloActions.setVisualizacao(false))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* visualizarCadastroModelo({ id }: GenericProps): SagaIterator {
  yield put(loadingActions.setLoading(true))
  try {
    const response = yield call(
      cadastroModeloController.getByIdModeloMensagemChatWoot,
      id
    )

    const modelos: CadastroModeloReq = {
      id: response?.data?.content?.id,
      atalho: response?.data?.content?.nome,
      descricao: response?.data?.content?.descricao
    }

    yield put(cadastroModeloActions.setRegister(modelos))
    yield put(cadastroModeloActions.setActiveTab('register'))
    yield put(cadastroModeloActions.setVisualizacao(true))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* atualizarCadastroModelo(): SagaIterator {
  const { register }: CADASTRO_MODELO = yield select(
    (state: ApplicationState) => state.cadastroModelo
  )
  try {
    yield put(loadingActions.setLoading(true))

    const data: CadastroModeloReq = {
      id: register.id,
      atalho: register.atalho,
      descricao: register.descricao
    }
    yield call(cadastroModeloController.updateModeloMensagemChatWoot, data)
    yield put(cadastroModeloActions.cleanRegister())
    yield put(
      cadastroModeloActions.setPaginacao({
        page: 0,
        pageSize: 10,
        totalRegistros: 0
      })
    )
    yield put(cadastroModeloActions.setPesquisa(null, 'filtro'))
    yield put(cadastroModeloActions.setPesquisa('', 'pesquisa'))
    yield put(cadastroModeloActions.getAllModeloMensagemSaga())
    yield put(cadastroModeloActions.setActiveTab('search'))
    toast.success('Modelo alterado com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getFiltrosCadastroModelo(): SagaIterator {
  const { search } = yield select(
    (state: ApplicationState) => state.cadastroModelo
  )

  const filtros = `${search.atalho || ''} ${
    search.descricao || search.filtro || ''
  }`.trim()

  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(cadastroModeloController.getfiltro, filtros)
    yield put(
      cadastroModeloActions.setAllCadastroModelo(response?.data?.content)
    )
  } catch (error) {
    console.error(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getModelosMensagem(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(
      cadastroModeloController.getModelosMensagemChatWoot
    )
    yield put(
      cadastroModeloActions.setModelosMensagemSelect(
        response?.data?.content || []
      )
    )
  } catch (error) {
    console.error(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
export function* watchCriarCadastroModelo() {
  yield takeEvery(TYPES.CRIAR_MODELO_MENSAGEM_SAGA, criarCadastroModelo)
}
export function* watchGetAllModeloMensagem() {
  yield takeEvery(TYPES.GET_ALL_MODELO_MENSAGEM_SAGA, getAllModeloMensagem)
}
export function* watchDeleteCadastroModelo() {
  yield takeEvery(
    TYPES.DELETE_MODELO_MENSAGEM_SAGA_DISPATCH,
    deleteCadastroModelo
  )
}
export function* watchEditarCadastroModelo() {
  yield takeEvery(
    TYPES.EDITAR_MODELO_MENSAGEM_SAGA_DISPATCH,
    editarCadastroModelo
  )
}
export function* watchVisualizarCadastroModelo() {
  yield takeEvery(
    TYPES.VISUALIZAR_MODELO_MENSAGEM_SAGA_DISPATCH,
    visualizarCadastroModelo
  )
}
export function* watchAtualizarCadastroModelo() {
  yield takeEvery(TYPES.ATUALIZAR_MODELO_MENSAGEM_SAGA, atualizarCadastroModelo)
}
export function* watchGetFiltrosCadastroModelo() {
  yield takeEvery(TYPES.GET_FILTRO_CADASTRO_SAGA, getFiltrosCadastroModelo)
}
export function* watchGetModelosMensagem() {
  yield takeEvery(TYPES.GET_MODELOS_MENSAGEM_SAGA, getModelosMensagem)
}
function* cadastroModeloSaga() {
  yield all([
    fork(watchCriarCadastroModelo),
    fork(watchGetAllModeloMensagem),
    fork(watchDeleteCadastroModelo),
    fork(watchEditarCadastroModelo),
    fork(watchVisualizarCadastroModelo),
    fork(watchAtualizarCadastroModelo),
    fork(watchGetFiltrosCadastroModelo),
    fork(watchGetModelosMensagem)
  ])
}

export default cadastroModeloSaga
